import { render, staticRenderFns } from "./Mutate.vue?vue&type=template&id=36ef020e"
import script from "./Mutate.vue?vue&type=script&lang=js"
export * from "./Mutate.vue?vue&type=script&lang=js"
import style0 from "./Mutate.vue?vue&type=style&index=0&id=36ef020e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports